import { render, staticRenderFns } from "./EtiquetasModalEdicion.vue?vue&type=template&id=287e257a&scoped=true&"
import script from "./EtiquetasModalEdicion.vue?vue&type=script&lang=ts&"
export * from "./EtiquetasModalEdicion.vue?vue&type=script&lang=ts&"
import style0 from "./EtiquetasModalEdicion.vue?vue&type=style&index=0&id=287e257a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287e257a",
  null
  
)

export default component.exports